import decorImgLeftTop from '@assets/media/images/decor-bg-left-top.svg';
import decorImgLeftBottom from '@assets/media/images/decor-bg-left-bottom.svg';
import decorImgRightTop from '@assets/media/images/decor-bg-right-top.svg';
import decorImgRightBottom from '@assets/media/images/decor-bg-right-bottom.svg';

const HeaderSpace = () => {

  return (
    <div className="cs-header-space">
      <div className="decor-imgs">
        <img src={decorImgLeftTop} alt="" className="decor-left-top" />
        <img src={decorImgLeftBottom} alt="" className="decor-left-bottom" />
        <img src={decorImgRightTop} alt="" className="decor-right-top" />
        <img src={decorImgRightBottom} alt="" className="decor-right-bottom" />
      </div>
    </div>
  );
};

export default HeaderSpace;